import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BaseUrl } from '../App';
import { Circles } from 'react-loader-spinner';
import { FadeLoader } from 'react-spinners';


const Xero = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [clientId, setClientId] = useState('');
  const [clientSecret, setClientSecret] = useState('');
  const [xeroStatus, setXeroStatus] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [successMessage, setSuccessMessage] = useState("")
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/settings.php`, {
        action: 'get_all_settings',
        api_key: "1"
      });

      if (response.data.status === 'true' && response.data.statuscode === 200) {
        const settings = response.data.response;
        const xeroClientId = settings.find(setting => setting.option_name === 'ct_xero_client_ID')?.option_value || '';
        const xeroClientSecret = settings.find(setting => setting.option_name === 'ct_xero_client_secret')?.option_value || '';
        const xeroStatusValue = settings.find(setting => setting.option_name === 'ct_xero_status')?.option_value || '';
        
        setClientId(xeroClientId);
        setClientSecret(xeroClientSecret);
        setXeroStatus(xeroStatusValue);
        setIsExpanded(xeroStatusValue === 'Y');
      } else {
        console.error('Failed to fetch settings:', response.data.response);
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
    finally {
      setLoading(false);
    }
  };

  const updateSetting = async (optionName, optionValue) => {
    setLoading(true);
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/settings.php`, {
        action: 'update_setting',
        api_key: '1', // Replace with the actual API key if dynamic
        option_name: optionName,
        option_value: optionValue !== undefined ? optionValue : '', // Allow empty values
      });

      if (response.data.status === 'true' && response.data.statuscode === 200) {
        setSuccessMessage("Update Xero Setting Successfully!")
        console.log(`Updated ${optionName} successfully`);
        return true;
      } else {
        console.error(`Failed to update ${optionName}:`, response.data.response);
        return false;
      }
    } catch (error) {
      console.error(`Error updating ${optionName}:`, error.message);
      return false;
    }finally {
      setLoading(false);
    }
  };

  const toggle = async () => {
    const newStatus = isExpanded ? 'N' : 'Y';
    setIsExpanded(!isExpanded);
    setXeroStatus(newStatus);
    await updateSetting('ct_xero_status', newStatus);
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
      const clientIdUpdated = await updateSetting('ct_xero_client_ID', clientId);
      const clientSecretUpdated = await updateSetting('ct_xero_client_secret', clientSecret);

      if (clientIdUpdated && clientSecretUpdated) {
        console.log("Settings saved successfully");
      } else {
        console.error("Failed to save some settings");
      }
    } catch (error) {
      console.error("Error saving settings:", error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="relative min-h-screen">
    {/* Loading Indicator */}
      {loading && (
           <div className="fixed inset-0 flex items-center justify-center z-50">
             <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
               <FadeLoader 
                 height={15}
                 width={5}
                 color="#ffffff"
                 ariaLabel="loading"
               />
               <h1 className="mt-1 text-lg text-white">Please wait...</h1>
             </div>
           </div>
         )}
         

    <div className="mx-auto mt-8 xl:px-72">
      {successMessage && (
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">{successMessage}</span>
        </div>
      )}

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">{error}</span>
        </div>
      )}
      <div className="flex items-left space-x-36">
        <span className="text-gray-700 font-bold text-xl">Xero setting</span>
        <button
          onClick={toggle}
          className={`relative w-12 h-6 rounded-full transition-all duration-500 flex items-center justify-center text-sm ${isExpanded ? 'bg-green-500 text-white' : 'bg-gray-300 text-gray-600'}`}
        >
          <div
            className={`w-6 h-6 bg-white rounded-full absolute top transition-all ${isExpanded ? 'right-0.5' : 'left-0.5'}`}
          />
        </button>
      </div>

      <div
        className={`overflow-hidden transition-all mt-10 duration-1000 ease-in-out`}
        style={{
          height: isExpanded ? 'auto' : '0',
          opacity: isExpanded ? '1' : '0',
          paddingTop: isExpanded ? '10px' : '0',
          paddingBottom: isExpanded ? '10px' : '0',
        }}
      >
        {isExpanded && (
          <div>
            <div>
              <label htmlFor="clientId" className="block text-gray-700 font-medium">
                Client ID
              </label>
              <input
                id="clientId"
                type="text"
                value={clientId}
                onChange={(e) => setClientId(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div className="mt-4">
              <label htmlFor="clientSecret" className="block text-gray-700 font-medium">
                Client Secret
              </label>
              <input
                id="clientSecret"
                type="text"
                value={clientSecret}
                onChange={(e) => setClientSecret(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div className="mt-4">
              <button
                onClick={handleSave}
                disabled={isSaving}
                className={`px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition ${isSaving ? 'opacity-50 cursor-not-allowed' : ''}`}
              >
                {isSaving ? 'Saving...' : 'Save'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
   
  </div>
  );
};

export default Xero;
